// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.background-color{
  background-color: #333;
}
.main-content {
  min-height: 100vh;
}
.rs-nav-item.rs-nav-item-active {
  color: #00badb;
}
.rs-sidenav-subtle .rs-sidenav-item.rs-sidenav-item-active {
  color: #00badb;
}
.rs-sidenav-subtle .rs-dropdown.rs-dropdown-selected-within .rs-sidenav-item-icon, .rs-sidenav-subtle .rs-sidenav-item.rs-sidenav-item-active {
  color: #00badb;
}
.rs-sidenav-subtle .rs-dropdown-item.rs-dropdown-item-active {
  color: #00badb;
}
.rs-sidenav-toggle {
  margin-top: 0;
}
.rs-pagination-btn{
  background-color: white;
}
.navbar-fixed {
  position: fixed;
  top: 0;
  left: 0;
  /*width: 240px;*/ /* Match this width to the actual width of your navbar */
  height: 100vh;
  z-index: 1000; /* Ensure it stays above other content */
  background-color: white; /* Ensure the background is visible */
  border-right: 1px solid #e5e5e5; /* Optional border for separation */
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,gBAAgB,EAAE,wDAAwD;EAC1E,aAAa;EACb,aAAa,EAAE,wCAAwC;EACvD,uBAAuB,EAAE,qCAAqC;EAC9D,+BAA+B,EAAE,mCAAmC;AACtE","sourcesContent":[".background-color{\n  background-color: #333;\n}\n.main-content {\n  min-height: 100vh;\n}\n.rs-nav-item.rs-nav-item-active {\n  color: #00badb;\n}\n.rs-sidenav-subtle .rs-sidenav-item.rs-sidenav-item-active {\n  color: #00badb;\n}\n.rs-sidenav-subtle .rs-dropdown.rs-dropdown-selected-within .rs-sidenav-item-icon, .rs-sidenav-subtle .rs-sidenav-item.rs-sidenav-item-active {\n  color: #00badb;\n}\n.rs-sidenav-subtle .rs-dropdown-item.rs-dropdown-item-active {\n  color: #00badb;\n}\n.rs-sidenav-toggle {\n  margin-top: 0;\n}\n.rs-pagination-btn{\n  background-color: white;\n}\n.navbar-fixed {\n  position: fixed;\n  top: 0;\n  left: 0;\n  /*width: 240px;*/ /* Match this width to the actual width of your navbar */\n  height: 100vh;\n  z-index: 1000; /* Ensure it stays above other content */\n  background-color: white; /* Ensure the background is visible */\n  border-right: 1px solid #e5e5e5; /* Optional border for separation */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
